import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { removeScrollbar } from "@enkor/design/mixins";

export const OptionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OptionContainer = styled.div`
  display: inline-flex;
`;

// NOTE: 실제 checkbox input
export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  border-radius: 8px;

  background-color: ${grayScale[200]};
`;

export const CheckboxLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px;

  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
`;

export const CheckboxText = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const CheckIconWrapper = styled.div<{ $isChecked: boolean }>`
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ $isChecked }) => ($isChecked ? pink.main : grayScale.main)};
  border-radius: 50%;

  background-color: ${({ $isChecked }) =>
    $isChecked ? pink.main : getOpacityColor(grayScale.black, 0.2)};
`;

export const ReasonTextarea = styled.textarea`
  width: calc(100% - 32px);
  height: 200px;
  margin: 16px;
  margin-top: 0;
  padding: 10px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  resize: none;

  &:focus {
    border: 1px solid ${grayScale.white};
  }

  &::placeholder {
    color: ${grayScale.main};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  ${removeScrollbar}
`;
